import React from 'react';
import { CellProps } from 'react-table';

import classNames from 'classnames';
import styles from '../assets/adminWork-actions.module.scss';
import { IAdminWork } from 'src/types/adminWork';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteInternalAction from './DeleteAdminWorkAction';

const AdminWorkActionsColumn: React.FunctionComponent<CellProps<IAdminWork>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IAdminWork>) => {
    return (
        <div className={classNames(styles.actions)}>
            {original.status !== 4 ? (
                <div className={'d-flex'}>
                    <Link
                        className="btn btn-info mr-2"
                        to={Router.generate(routes.ADMIN_WORK_EDIT, { id: original.id })}
                    >
                        <FontAwesomeIcon icon={faPencilAlt} />
                    </Link>
                    <DeleteInternalAction data={original} />
                </div>
            ) : null}
        </div>
    );
};

export default AdminWorkActionsColumn;
